import { shopIndexPage } from 'utils/pageTemplates/shopIndexPage';

const { getStaticProps, ShopIndexPageComponent } = shopIndexPage({
  category: 'supplements',
});

export { getStaticProps };
export default ShopIndexPageComponent;
